export const TRANSLATIONS_EN_DASHBOARD_AND_KNOWLEDGE = {
  "dashboard.title": "Dashboard",
  "dashboard.documents": "Documents",
  "dashboard.credits": "Credits",
  "dashboard.users": "Active Users",
  "dashboard.questions": "Questions",
  "dashboard.embeddings": "Embeddings",
  "dashboard.status": "System Status",
  "dashboard.widget.plan_usage": "Plan Usage",
  "dashboard.widget.csv_stats": "CSV Statistics",
  "dashboard.widget.csv_stats.uploaded": "CSV Files Uploaded",
  "dashboard.widget.csv_stats.queries": "Queries Executed",
  "dashboard.widget.documents_stats": "Document Statistics",
  "dashboard.widget.documents_stats.count": "Documents Uploaded",
  "dashboard.widget.documents_stats.duplicates": "Duplicates",
  "dashboard.widget.documents_stats.this_month": "This Month",
  "dashboard.widget.email_stats": "Email Statistics",
  "dashboard.widget.email_stats.sent": "Emails Processed",
  "dashboard.widget.email_stats.received": "Emails Converted to Tasks",
  "dashboard.widget.tokens_breakdown": "Tokens Breakdown",
  "dashboard.widget.tokens_breakdown.input": "Tokens Used (embeddings)",
  "dashboard.widget.tokens_breakdown.output": "Tokens Used (RAG)",
  "dashboard.widget.tokens_breakdown.exceeded": "Token limit exceeded",
  "dashboard.widget.rag_queries": "RAG Queries",
  "dashboard.widget.rag_queries.count": "RAG Queries",
  "dashboard.widget.rag_queries.top_users": "Top users:",
  "dashboard.widget.plan_usage.used": "Used",
  "dashboard.widget.plan_usage.remaining": "Remaining",
  "dashboard.widget.plan_usage.total": "Total",
  "dashboard.widget.plan_usage.exceeded": "Plan limit exceeded",
  "dashboard.widget.user_activity": "User Activity",
  "dashboard.widget.inactive_users": "Inactive Users",
  "dashboard.widget.user_activity.active": "Active Users",
  "dashboard.widget.user_activity.inactive": "Inactive Users",
  "dashboard.widget.inactive_users.count": "Inactive Users",
  "dashboard.loading": "Loading...",
  "dashboard.context_menu.add_widget": "Add Widget",
  "dashboard.context_menu.remove_widget": "Remove Widget",
  "dashboard.context_menu.title": "Available Widgets",
  "dashboard.context_menu.group.others": "Others",
  "dashboard.context_menu.widget.csv": "CSV",
  "dashboard.context_menu.widget.consultas_rag": "RAG Queries",
  "dashboard.context_menu.widget.tokens": "Tokens",
  "dashboard.context_menu.widget.emails": "Emails",
  "dashboard.context_menu.widget.documentos": "Documents",
  "dashboard.context_menu.widget.usuarios_inactivos": "Inactive Users",
  "dashboard.empty": "Right-click to add widgets to the dashboard.",
  "dashboard.widget.title.plan_usage": "Plan Usage",
  "dashboard.widget.title.csv_stats": "CSV Statistics",
  "dashboard.widget.title.documents_stats": "Document Statistics",
  "dashboard.widget.title.email_stats": "Email Statistics",
  "dashboard.widget.title.tokens_breakdown": "Tokens Breakdown",
  "dashboard.widget.title.rag_queries": "RAG Queries",
  "dashboard.widget.title.user_activity": "User Activity",
  "dashboard.widget.title.inactive_users": "Inactive Users",
  "dashboard.context_menu.widget.plan_usage": "Plan Usage",
  "dashboard.context_menu.widget.csv_stats": "CSV Statistics",
  "dashboard.context_menu.widget.documents_stats": "Document Statistics",
  "dashboard.context_menu.widget.email_stats": "Email Statistics",
  "dashboard.context_menu.widget.tokens_breakdown": "Tokens Breakdown",
  "dashboard.context_menu.widget.rag_queries": "RAG Queries",
  "dashboard.context_menu.widget.user_activity": "User Activity",
  "dashboard.context_menu.widget.inactive_users": "Inactive Users",
  "dashboard.widget.user_activity.last_active": "Last Active",
  "dashboard.widget.user_activity.user": "User",
  "dashboard.active_users_this_month": "Active users this month:",
  "dashboard.active_users_today": "Active users today",
  "dashboard.name": "Name",
  "dashboard.last_login": "Last login",
  "dashboard.last_activity": "Last activity",
  "dashboard.inactive_users_this_month": "Inactive users this month:",
  "dashboard.days_without_activity": "days without activity",
  "dashboard.no_inactive_users": "No inactive users this month.",
  "dashboard.questions_today": "Questions today",
  "dashboard.system_status": "System status",
  "dashboard.action": "Action",
  "dashboard.widget.inactive_users.user": "User",
  "dashboard.widget.inactive_users.last_active": "Last Active",
  "dashboard.context_menu.no_widgets": "No widgets to add",
  "changes.title": "Changes between versions",
  "changes.empty": "No changes detected.",
  "changes.filter.allSeverities": "All severities",
  "changes.filter.allStatuses": "All statuses",
  "changes.general.loading": "Loading...",
  "changes.general.retry": "Retry",
  "changes.error.message": "Could not load changes.",
  "changes.evidence.before": "Before",
  "changes.evidence.after": "After",
  "changes.action.confirm": "Confirm",
  "changes.action.needsReview": "Needs review",
  "changes.action.dismiss": "Dismiss",
  "changes.action.dismissReason": "Reason (optional)",
  "changes.severity.informational": "informational",
  "changes.severity.low": "low",
  "changes.severity.medium": "medium",
  "changes.severity.high": "high",
  "changes.severity.critical": "critical",
  "changes.status.detected": "detected",
  "changes.status.needs_review": "needs review",
  "changes.status.confirmed": "confirmed",
  "changes.status.dismissed": "dismissed",
  "changes.status.superseded": "superseded",
  "changes.category.legal": "legal",
  "changes.category.financial": "financial",
  "changes.category.operational": "operational",
  "changes.category.compliance": "compliance",
  "changes.category.commercial": "commercial",
  "changes.category.technical": "technical",
  "changes.category.human_resources": "HR",
  "changes.category.security": "security",
  "changes.category.general": "general",
  "alerts.title": "Knowledge alerts",
  "alerts.empty": "No active alerts.",
  "alerts.filter.allSeverities": "All severities",
  "alerts.filter.allStatuses": "All statuses",
  "alerts.filter.allSources": "All sources",
  "alerts.general.loading": "Loading...",
  "alerts.general.retry": "Retry",
  "alerts.error.message": "Could not load alerts.",
  "alerts.severity.informational": "informational",
  "alerts.severity.low": "low",
  "alerts.severity.medium": "medium",
  "alerts.severity.high": "high",
  "alerts.severity.critical": "critical",
  "alerts.status.detected": "detected",
  "alerts.status.acknowledged": "acknowledged",
  "alerts.status.snoozed": "snoozed",
  "alerts.status.resolved": "resolved",
  "alerts.status.dismissed": "dismissed",
  "alerts.status.expired": "expired",
  "alerts.source.expiration": "expiration",
  "alerts.source.change": "change",
  "alerts.refs.title": "Source references",
  "alerts.refs.open": "Open source",
  "alerts.action.acknowledge": "Acknowledge",
  "alerts.action.snooze": "Snooze",
  "alerts.action.snoozeDays": "Days",
  "alerts.action.resolve": "Resolve",
  "alerts.action.dismiss": "Dismiss",
  "alerts.action.dismissReason": "Reason (optional)",
  "alerts.action.openSource": "View source",
  "dashboard.knowledge.title": "Knowledge dashboard",
  "dashboard.knowledge.loading": "Loading...",
  "dashboard.knowledge.error": "Could not load the dashboard.",
  "dashboard.knowledge.retry": "Retry",
  "dashboard.knowledge.placeholder": "No data yet.",
  "dashboard.knowledge.changesBySeverity": "Changes by severity",
  "dashboard.knowledge.changesByCategory": "Changes by category",
  "dashboard.knowledge.expirationsByHorizon": "Expirations by horizon",
  "dashboard.knowledge.alertsByStatus": "Alerts by status",
  "knowledge.title": "Knowledge",
  "knowledge.tabs.entities": "Entities",
  "knowledge.tabs.expirations": "Expirations",
  "knowledge.loading": "Loading…",
  "knowledge.retry": "Retry",
  "knowledge.entities.subtitle": "Entities detected across your documents.",
  "knowledge.entities.searchPlaceholder": "Search by name or alias…",
  "knowledge.entities.search": "Search",
  "knowledge.entities.sources": "Sources",
  "knowledge.entities.empty": "No entities to show.",
  "knowledge.entities.error": "Could not load entities.",
  "knowledge.timeline.title": "Timeline",
  "knowledge.timeline.empty": "No readable events for this entity.",
  "knowledge.timeline.error": "Could not load the timeline.",
  "knowledge.expirations.subtitle": "Upcoming expirations detected with evidence.",
  "knowledge.expirations.evidence": "Evidence",
  "knowledge.expirations.dismiss": "Dismiss",
  "knowledge.expirations.dismissed": "Expiration dismissed.",
  "knowledge.expirations.dismissError": "Could not dismiss the expiration.",
  "knowledge.expirations.empty": "No upcoming expirations.",
  "knowledge.expirations.error": "Could not load expirations.",
  "knowledge.type.cliente": "Customer",
  "knowledge.type.proveedor": "Supplier",
  "knowledge.type.contrato": "Contract",
  "knowledge.type.politica": "Policy",
  "knowledge.type.area": "Area",
  "knowledge.type.riesgo": "Risk",
};
